import { render, staticRenderFns } from "./PopularRoutes.vue?vue&type=template&id=70d8f726&scoped=true&"
import script from "./PopularRoutes.vue?vue&type=script&lang=js&"
export * from "./PopularRoutes.vue?vue&type=script&lang=js&"
import style0 from "./PopularRoutes.vue?vue&type=style&index=0&id=70d8f726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8f726",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d8f726')) {
      api.createRecord('70d8f726', component.options)
    } else {
      api.reload('70d8f726', component.options)
    }
    module.hot.accept("./PopularRoutes.vue?vue&type=template&id=70d8f726&scoped=true&", function () {
      api.rerender('70d8f726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PopularRoutes.vue"
export default component.exports